import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';
import { AuthenticationStepType } from '@getaccept/lib-shared-new/src/authentication/types/enums/authentication-step-type';
import { RedirectURLError } from '@getaccept/lib-shared-new/src/universal-link/types/redirect-url-error';
import type { VerifyLinkResponse } from '@getaccept/lib-shared-new/src/universal-link/types/verify-link-response';

export class IdentifyRecipientHelper {
  static getHelpMessage(emailInvalid: boolean): string {
    if (emailInvalid) {
      return t('invalid-email');
    }
    return '';
  }

  static getConsentStep({ consentText, entityName }: Partial<VerifyLinkResponse>) {
    return {
      type: AuthenticationStepType.GdprConsent,
      data: {
        text: consentText,
        textData: {
          entity: {
            name: entityName,
          },
        },
      },
    };
  }

  static getErrorMessage(error): string {
    if (!error) {
      return '';
    }
    switch (error) {
      case RedirectURLError.GDPRConsentRequired:
        return t('gdpr-consent-required');
      case RedirectURLError.FailedToSaveGDPRConsent:
        return t('failed-to-save-gdpr-consent');
      default:
        return t('could-not-verify-your-email');
    }
  }

  static isSubmitDisabled(email: string, consentGiven: boolean, requireGdprConsent: boolean) {
    return !email || (requireGdprConsent && !consentGiven);
  }
}
